import { HeadlineRisk } from "./HeadlineRisk.model";
import { RiskType, RiskTypeEnum } from "./RiskType.model";

export class RiskConfig {
  riskTypes: RiskType[];
  headlineRisks: HeadlineRisk[];

  constructor(riskTypes: RiskType[], headlineRisks: HeadlineRisk[]) {
    this.riskTypes = riskTypes;
    this.headlineRisks = headlineRisks;
  }
}

//Static risk categories. adding as RiskType for now
export class RiskCategory {
  public static AllRisks = new RiskType(RiskTypeEnum.all, "");
  public static MyRisks = new RiskType(RiskTypeEnum.all, "MyRisks");
  public static MyManagerRisks = new RiskType(RiskTypeEnum.all, "MyManagerRisks");
  public static Emerging = new RiskType(RiskTypeEnum.all, "Emerging");

  public static Strategic = new RiskType(RiskTypeEnum.strategic, "Strategic");
  public static Operational = new RiskType(RiskTypeEnum.operational, "Operational");
  public static Financial = new RiskType(RiskTypeEnum.financial, "Financial");
}
